import React from "react";
import { IOptionCode } from "tsi-common-react/src/models/catalogue";

import { templates } from "@reactivated";

import { PDPChangeVariantOptionBlock } from "../apps/product-detail/PDPChangeVariantOptionBlock";

export const Template = (
    props: templates.ChangeVariantOptionBlockTemplate,
): React.JSX.Element => {
    return (
        <div>
            <PDPChangeVariantOptionBlock
                attributeCode={props.attribute_code as IOptionCode}
                initialOptionValuesData={props.initial_option_values_data}
                initialSelectedValue={props.initial_selected_value}
            />
        </div>
    );
};
